// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3fwwJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__3a0Vp"};